import { memo } from "react";
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals"
import { getAppInfoData } from "../../utils/global_functions";
import { APP_INFO_PARAMS } from "../../utils/global_variables";


const UsageGuide = () => {

    const dispatch = useDispatch()
    const modals = useSelector(state => state?.modals?.modals)
    const objusageGuide = getAppInfoData(APP_INFO_PARAMS.APP_BREEZE_FAQ_URL);

    const handleClose = () => {
        dispatch(handleModal([{ "USAGE_GUIDE": false }]))
    }

    return (
        <>
            <BzModal size='lg' show={modals['USAGE_GUIDE']} onHide={handleClose}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div data-testid='qr-login-help-modal-header' className='font-medium font-size4 color-text'>Usage Guide</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-center'>                           
                            <iframe src={objusageGuide} className='usage-guide-wrapper' title='Usage Guide'/>                            
                        </Col>
                    </Row>
                </Container>                    
                </BzModalBody>
            </BzModal>
        </>
    );
};

export default memo(UsageGuide);